import React from "react";
import { Route, Switch } from "react-router-dom";
import Container from "react-bootstrap/Container";

import "./App.css";

import HomePage from "./pages/HomePage";
import NeurospherePage from "./pages/NeurospherePage";
import LabMembersPage from "./pages/LabMembersPage";
import TutorialPage from "./pages/TutorialPage";
import PublicationsPage from "./pages/PublicationsPage";
import ExercisesPage from "./pages/ExercisesPage";
import NoMatchPage from "./pages/NoMatchPage";
import Footer from "./components/Footer";
import Header from "./components/Header";

class App extends React.Component {
  render() {
    return (
      <div className="page-container">
        <Container className="p-0 body-container" fluid={true}>
          <main role="main" className="content-wrap">
            <Header />
            <Switch>
              <Route path="/" exact render={() => <HomePage />} />
              <Route
                path="/tutorial"
                render={(match) => <TutorialPage {...match} />}
              />
              <Route
                path="/neurosphere"
                exact
                render={() => <NeurospherePage />}
              />
              <Route path="/exercises" exact render={() => <ExercisesPage />} />
              <Route
                path="/publications"
                exact
                render={() => <PublicationsPage />}
              />
              <Route path="/people" exact render={() => <LabMembersPage />} />
              <Route component={NoMatchPage} />
            </Switch>
          </main>
          <Footer />
        </Container>
      </div>
    );
  }
}

export default App;
